/**
 * /app/trusts/$id/document-review/$jobId — Document-review (route shell).
 *
 * WS-4 §5.1: the review-and-confirm surface for an ingestion job, scoped under
 * the trust tab-set. The screen body lives in `./document-review-screen.tsx`
 * and is lazy-loaded via `lazyRouteComponent` so the field rows + view-source
 * overlay + conflict cards leave the entry bundle — this is a deep sub-route,
 * not a first-paint screen. Same shell+screen pattern as `./documents.tsx` /
 * `./audit.tsx`.
 *
 * The `$jobId` param is the ingestion job the screen polls
 * (`GET /v1/ingestion-jobs/{id}`); `$id` (the trust) comes from the parent
 * segment and scopes the tab nav + the confirm cache invalidation.
 *
 * Hand-added to `routeTree.gen.ts` mirroring the sibling param route
 * `resolutions/$rid/sign` (do NOT regen the routeTree via the plugin — that
 * rewrites custom URLs; see `meetings.new.tsx`).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/document-review/$jobId')({
  component: lazyRouteComponent(
    () => import('./document-review-screen'),
    'DocumentReviewScreen',
  ),
});
